var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('v-row',{staticClass:"container__row"},[_vm._t("component")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }